// Module
var code = `<form class="form-horizontal" dice-form model="reportTemplateController.reportTemplate" validator="report-template" name="reportTemplateController.templateForm" ng-submit="reportTemplateController.save(reportTemplateController.templateForm)" check-for-unsaved-changes="reportTemplateController.templateForm"> <div class="panel panel-default"> <div class="panel-heading" fix-to-top="panel-heading-fixed"> <h1 class="clearfix"> <back-to-top></back-to-top> <span>{{ reportTemplateController.reportTemplate.names | description }}</span> <div class="panel-heading-buttons"> <copy-button btn-type="outline" ng-if="reportTemplateController.reportTemplate.id !== undefined" ui-sref="report-template-copy({ id: reportTemplateController.reportTemplate.id })"></copy-button> <delete-button btn-type="outline" on-delete="reportTemplateController.remove()"></delete-button> <cancel-button btn-type="outline" ui-sref="report-template-list"></cancel-button> <save-button btn-type="outline"></save-button> </div> </h1> </div> <uib-tabset> <uib-tab heading="{{ 'Page.ReportTemplate.General' | translate }}"> <div class="panel-body" ng-include="'general.html'"></div> </uib-tab> <uib-tab heading="{{ 'Page.ReportTemplate.Tags' | translate }}"> <div ng-include="'tags.html'"></div> </uib-tab> <uib-tab heading="{{ 'Page.ReportTemplate.MemberTypes' | translate }}"> <div ng-include="'members.html'"></div> </uib-tab> <uib-tab heading="{{ 'Page.ReportTemplate.Headers' | translate }}"> <div ng-include="'table-headers.html'"></div> </uib-tab> <uib-tab heading="{{ 'Page.ReportTemplate.FilterQuestions' | translate }}"> <div ng-include="'filter-questions.html'"></div> </uib-tab> <uib-tab heading="{{ 'Page.ReportTemplate.QuestionTypes' | translate }}"> <div ng-include="'question-types.html'"></div> </uib-tab> <uib-tab heading="{{ 'Page.ReportTemplate.Attributes' | translate }}"> <div ng-include="'attributes.html'"></div> </uib-tab> </uib-tabset> </div> </form> ${"<" + "script"} type="text/ng-template" id="general.html"> <form-input input-id="evaluationType" label="{{ 'Page.ReportTemplate.EvaluationType' | translate }}"></form-input>

  <form-group label="Page.ReportTemplate.Type">
    <enum-select ng-model="reportTemplateController.reportTemplate.reportType" type="report-type"></enum-select>
  </form-group>

  <form-input input-id="externalId" label="Page.ReportTemplate.ExternalId"></form-input>
  <form-input input-id="names" label="Page.ReportTemplate.Name"></form-input>
  <form-input input-id="startDate" label="Page.ReportTemplate.StartDate"></form-input>
  <form-input input-id="endDate" label="Page.ReportTemplate.EndDate"></form-input>
  <form-input input-id="cardsView" label="Page.ReportTemplate.CardsView"></form-input>
  <form-input input-id="showBlocks" label="Page.ReportTemplate.ShowBlocks"></form-input>
  <form-input input-id="showTemplateOnly" label="Page.ReportTemplate.ShowTemplateOnly"></form-input>
  <form-input input-id="showEmptyOptions" label="Page.ReportTemplate.ShowEmptyOptions"></form-input>
  <form-input input-id="showBenchmarks" label="Page.ReportTemplate.ShowBenchmarks"></form-input>
  <form-input input-id="showFeedbackLast" label="Page.ReportTemplate.ShowFeedbackLast"></form-input>
  <form-input input-id="feedbackEditable" label="Page.ReportTemplate.FeedbackEditable"></form-input>
  <form-input input-id="indexPerBlock" label="Page.ReportTemplate.IndexPerBlock"></form-input>
  <form-input input-id="minimumRespondents" label="Page.ReportTemplate.MinimumRespondents"></form-input>
  <form-input input-id="averageGradeQuestions" label="Page.ReportTemplate.AverageGradeQuestions"></form-input>
  <form-input input-id="includePreviousYears" label="Page.ReportTemplate.IncludePreviousYears"></form-input>
  <form-input input-id="sequence" label="Page.ReportTemplate.Sequence"></form-input>

  <form-group label="Page.ReportTemplate.ParticipationStatuses">
    <enum-select-multiple
      ng-model="reportTemplateController.reportTemplate.participationStatuses"
      type="participation-status">
    </enum-select-multiple>
  </form-group>

  <form-group label="Page.ReportTemplate.BlockTypes">
    <enum-select-multiple
      ng-model="reportTemplateController.blockTypes"
      type="block-type">
    </enum-select-multiple>
  </form-group>

  <form-input input-id="personal" label="{{ 'Page.ReportTemplate.Personal' | translate }}"></form-input> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="table-headers.html"> <table class="table m-b-0">
    <thead>
      <tr>
        <th translate>Page.ReportTemplate.Headers.Labels</th>
        <th translate>Page.ReportTemplate.Headers.Values</th>
        <th>
          <create-button
            class="pull-right"
            btn-size="xs"
            ng-click="reportTemplateController.addHeader()">
          </create-button>
        </th>
      </tr>
    </thead>
    <tbody dnd-list="reportTemplateController.headers">
      <tr ng-repeat="header in reportTemplateController.headers"
          dnd-draggable="header"
          dnd-moved="reportTemplateController.onMoved(reportTemplateController.headers, \$index)"
          dnd-effect-allowed="move"
          dnd-selected="header.selected = !header.selected">
        <td>
          <description-input ng-model="header.labels"></description-input>
        </td>
        <td>
          <input class="form-control" ng-model="header.values">
        </td>
        <td>
          <delete-button btn-size="xs" class="pull-right" on-delete="reportTemplateController.removeHeader(\$index)"></delete-button>
        </td>
      </tr>
    </tbody>
  </table> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="filter-questions.html"> <div class="alert alert-info m-10">
    <i class="fa fa-info-circle"></i> <span translate>Page.ReportTemplate.FilterQuestions.Explanation</span>
  </div>

  <form-group label="Page.ReportTemplate.EnableFilterQuestions">
    <toggle-input toggle-id="filterQuestions" ng-model="reportTemplateController.reportTemplate.filterQuestions"
                  label="{{ 'Page.ReportTemplate.EnableFilterQuestions' | translate }}"></toggle-input>
  </form-group>

  <form-group label="Page.ReportTemplate.OpenQuestionsOrder" ng-if="reportTemplateController.reportTemplate.filterQuestions">
    <div class="radio">
      <label>
        <input
          type="radio"
          ng-model="reportTemplateController.reportTemplate.inOrder"
          ng-value="true" /><span translate>Page.ReportTemplate.InOrder</span>
      </label>
      <label>
        <input
          type="radio"
          ng-model="reportTemplateController.reportTemplate.inOrder"
          ng-value="false" /><span translate>Page.ReportTemplate.Readable</span>
      </label>
    </div>
  </form-group>

  <div class="form-group p-l-10 p-r-10" ng-show="reportTemplateController.reportTemplate.filterQuestions">
    <div class="col-sm-12">
      <report-question-select
        ng-model="reportTemplateController.reportTemplate.questionTemplates"
        evaluation-type="reportTemplateController.reportTemplate.evaluationType"
        hide-open-questions="false">
      </report-question-select>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="question-types.html"> <table class="table m-b-0">
    <thead>
      <tr>
        <th translate>Page.ReportTemplate.QuestionTypes.Type</th>
        <th translate>Page.ReportTemplate.QuestionTypes.Visualization</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="question in reportTemplateController.questions">
        <td>{{ question.name }}</td>
        <td><enum-select ng-model="question.visualization" type="report-visualization"></enum-select></td>
      </tr>
    </tbody>
  </table> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="tags.html"> <table class="table m-b-0">
    <thead>
      <tr>
        <th translate>Page.ReportTemplate.Tags.Label</th>
        <th translate>Page.ReportTemplate.Tags.Name</th>
        <th translate>Page.ReportTemplate.Tags.FilterName</th>
        <th translate>Page.ReportTemplate.Tags.FilterValue</th>
        <th>
          <create-button
            class="pull-right"
            btn-size="xs"
            ng-click="reportTemplateController.addTag()">
          </create-button>
        </th>
      </tr>
    </thead>
    <tbody dnd-list="reportTemplateController.tags">
      <tr ng-repeat="tag in reportTemplateController.tags"
          dnd-draggable="tag"
          dnd-moved="reportTemplateController.onMoved(reportTemplateController.tags, \$index)"
          dnd-effect-allowed="move"
          dnd-selected="tag.selected = !tag.selected"
          ng-click="reportTemplateController.showTag(tag)">
        <td>{{ tag.label }}</td>
        <td>{{ tag.name }}</td>
        <td>{{ tag.filterName }}</td>
        <td>{{ tag.filterValue }}</td>
        <td>
          <delete-button btn-size="xs" class="pull-right" on-delete="reportTemplateController.removeTag(\$index)"></delete-button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="m-t-10" ng-if="reportTemplateController.tag !== undefined">
    <h2 class="text-center">{{ reportTemplateController.tag.label }}</h2>

    <form-group label="Page.ReportTemplate.Tags.Label">
      <input class="form-control" ng-model="reportTemplateController.tag.label">
    </form-group>
    <form-group label="Page.ReportTemplate.Tags.Name">
      <element-select ng-model="reportTemplateController.tag.name"></element-select>
    </form-group>
    <form-group label="Page.ReportTemplate.Tags.FilterName">
      <element-select ng-model="reportTemplateController.tag.filterName"></element-select>
    </form-group>
    <form-group label="Page.ReportTemplate.Tags.FilterValue">
      <input class="form-control" ng-model="reportTemplateController.tag.filterValue">
    </form-group>

    <div class="form-group">
      <div class="col-sm-12">
        <table class="table m-b-0">
          <thead>
            <tr>
              <th colspan="2" translate>Page.ReportTemplate.Tags.Groups</th>
              <th>
                <create-button btn-size="xs" class="pull-right" ng-click="reportTemplateController.addTagGroup(reportTemplateController.tag)"></create-button>
              </th>
            </tr>
            <tr>
              <th translate>Page.ReportTemplate.Tags.Groups.Value</th>
              <th translate>Page.ReportTemplate.Tags.Groups.Label</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="group in reportTemplateController.tag.groups">
              <td>
                <input class="form-control" ng-model="group.value">
              </td>
              <td>
                <input class="form-control" ng-model="group.label">
              </td>
              <td>
                <delete-button btn-size="xs" class="pull-right" on-delete="reportTemplateController.removeTagGroup(reportTemplateController.tag, \$index)"></delete-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="members.html"> <table class="table m-b-0">
    <thead>
      <th translate>Page.ReportTemplate.MemberTypes</th>
      <th translate>Page.ReportTemplate.ShowMember</th>
      <th translate>Page.ReportTemplate.ShowFeedback</th>
      <th translate>Page.ReportTemplate.Access</th>
      <th>
        <base-button class="pull-right" btn-size="sm" ng-click="reportTemplateController.addMemberType()">
          <i class="fa fa-plus"></i> {{ 'Generic.Add' | translate }}
        </base-button>
      </th>
    </thead>
    <tbody>
      <tr ng-repeat="type in reportTemplateController.reportTemplate.memberTypes">
        <td>
          <member-type-select ng-model="type.memberType" evaluation-type="reportTemplateController.reportTemplate.evaluationType"></member-type-select>
        </td>
        <td>
          <toggle-input ng-model="type.showMember" label="{{ 'Page.ReportTemplate.ShowMember' | translate }}"></toggle-input>
        </td>
        <td>
          <toggle-input ng-model="type.showFeedback" label="{{ 'Page.ReportTemplate.ShowFeedback' | translate }}"></toggle-input>
        </td>
        <td>
          <enum-select ng-model="type.accessType" type="report-member-type-access-type"></enum-select>
        </td>
        <td>
          <delete-button class="pull-right" btn-size="xs" btn-context="danger" on-delete="reportTemplateController.removeMemberType(\$index)"></delete-button>
        </td>
      </tr>
    </tbody>
  </table> ${"<" + "/script"}> ${"<" + "script"} type="text/ng-template" id="attributes.html"> <table class="table m-b-0">
    <thead>
      <th translate>Page.ReportTemplate.Attributes.Type</th>
      <error-fields field="attributes[].type"></error-fields>
      <th translate>Page.ReportTemplate.Attributes.Tooltip</th>
      <th>
        <base-button class="pull-right" btn-size="sm" ng-click="reportTemplateController.addAttribute()">
          <i class="fa fa-plus"></i> {{ 'Generic.Add' | translate }}
        </base-button>
      </th>
    </thead>
    <tbody>
      <tr>
        <td colspan="3" ng-show="!(reportTemplateController.reportTemplate.attributes.length > 0)">
          <no-results></no-results>
        </td>
      </tr>
      <tr ng-repeat="attribute in reportTemplateController.reportTemplate.attributes">
        <td>
          <enum-select ng-model="attribute.type" type="report-template-attribute-type"></enum-select>
        </td>
        <td>
          <description-input ng-model="attribute.tooltips"></description-input>
        </td>
        <td>
          <delete-button class="pull-right" btn-size="xs" btn-context="danger" on-delete="reportTemplateController.removeAttribute(\$index)"></delete-button>
        </td>
      </tr>
    </tbody>
  </table> ${"<" + "/script"}> `;
// Exports
module.exports = code;